//import * as FileSystem from 'expo-file-system';
import * as path from 'path';
import * as FileSystem from 'fs';
//import { unzip } from 'react-native-zip-archive';

import { deleteEpaperFolder, deleteFile } from './deleteEpaperFolder';

import { checkIfFolderExistsByString } from './checkIfFolderExists';
import { createFolderByString } from './createFolder';

import { createWriteStream } from 'node:fs';
import { writeFile } from 'node:fs/promises'
import * as Stream from 'node:stream';
import { promisify } from 'node:util';
//import fetch from 'node-fetch';

import * as unzipit from 'unzipit';
import { resolve } from 'node:path';
unzipit.setOptions({workerURL: 'unzipit/dist/unzipit-worker.js'});

const apiKey = 'a74aebef-c08c-44fc-b354-ed4337878fef';

// For server development
const GETINFOURL = 'https://one-app.boyens-api.de/api/infoFile';
const PREVIEW_IMG_URL = 'https://one-app.boyens-api.de/api/file/';
const BASE_FILE_URL = 'https://one-app.boyens-api.de/api/file/';



/*
// For local app development
if (Platform.OS == "android") {
  GETINFOURL = 'http://10.0.2.2:3000/api/InfoFile';
  PREVIEW_IMG_URL = 'http://10.0.2.2:3000/api/file/';
  BASE_FILE_URL = 'http://10.0.2.2:3000/api/file/';
} else if (Platform.OS == "ios") {
  GETINFOURL = 'http://localhost:3000/api/InfoFile';
  PREVIEW_IMG_URL = 'http://localhost:3000/api/file/';
  BASE_FILE_URL = 'http://localhost:3000/api/file/';
}
*/

// For web testing - Start \\

const unzip = async (uri: string, unzipUri: string) => {
  return new Promise(async (resolve, reject) => {

    const buffer = await FileSystem.readFileSync(uri);

    const {zip, entries} = await unzipit.unzip(new Uint8Array(buffer));

    const entriesLength = Object.keys(entries).length;

    let fileCnt = 0;

    for (const entry of Object.values(entries)) {
      fileCnt++;

      if (entry.isDirectory) {
        continue;
      }
      const data = await entry.arrayBuffer();
  
      const dst = path.join(unzipUri, entry.name);
  
      // WARNING:!!! It's up to you to check this path
      // is ok. If a zip file was constructed with a name like
      // ../../../.bashrc or something like that it could
      // write outside the dstPath
      
      FileSystem.mkdirSync(path.dirname(dst), {recursive: true});
      FileSystem.writeFileSync(dst, new Uint8Array(data));

      if(fileCnt === entriesLength) {
        resolve(true);
      }
    }


    

  });
};

/*
const downloadFile = async (url: string, path: string) => {
  return new Promise(async (resolve, reject) => {

    const res: any = await fetch(url);
    const fileStream = FileSystem.createWriteStream(path);
    await new Promise((resolve, reject) => {
        res.body.pipe(fileStream);
        res.body.on("error", reject);
        fileStream.on("finish", resolve);
    });

  });
};
*/
// For web testing - End \\


export const fetchSingle = async (date: string, edition: string) => {
  try {
    const url = `https://one-app.boyens-api.de/api/file/${date}/${edition}/single`;
    const fileUri = `./epaper/${date}.${edition}.zip`;
    const unzipUri = `./epaper/${date}/${edition}/`;

    const folderExists: any = await fetch(
      'http://localhost:3000/web-server-api/checkIfFolderExists',
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          "date": date,
          "edition": edition
        }),
      }
    );

    if (!folderExists.response) {
      //await createFolder(magazine.date, magazine.edition);
      const createFolder = await fetch(
        'http://localhost:3000/web-server-api/createFolder',
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            "date": date,
            "edition": edition
          }),
        }
      );

      const streamPipeline = promisify(Stream.pipeline);

      const response = await fetch(
        url, 
        {
          headers: { 'api-key': apiKey }
        }
      );
      
      if (!response.ok){ 
          throw new Error(`unexpected response ${response.statusText}`); 
      }
      
      await streamPipeline(response.body, createWriteStream(fileUri));
      
      await unzip(fileUri, unzipUri);

    }
    else {
      const streamPipeline = promisify(Stream.pipeline);

      const response = await fetch(
        url, 
        {
          headers: { 'api-key': apiKey }
        }
      );
      
      if (!response.ok){ 
          throw new Error(`unexpected response ${response.statusText}`); 
      }
      
      await streamPipeline(response.body, createWriteStream(fileUri));
      
      await unzip(fileUri, unzipUri);
    }



    

    //return true;


    /*
    const downloadResumable = FileSystem.createDownloadResumable(
      url,
      fileUri,
      { headers: { 'api-key': apiKey } }
    );

    const { uri } = await downloadResumable.downloadAsync();
    await unzip(uri, unzipUri);
    */
  } catch (error) {
    console.error('Download and Unzip Error:', error);
  }
};

export const fetchImages = async (date: string, edition: string) => {
  return new Promise(async (resolve, reject) => {
    try {
      const url = `https://one-app.boyens-api.de/api/file/${date}/${edition}/images`;
  
      const fileUri = `./epaper/${date}.${edition}_img.zip`;
      //const unzipUri = `./epaper/${date}/${edition}/img/`;
      
      const unzipUri = `./epaper/${date}/img/`;

      const folderExists: any = await fetch(
        'http://localhost:3000/web-server-api/checkIfFolderExists',
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            "date": date,
            "edition": edition
          }),
        }
      );
  
      if (!folderExists.response) {
        //await createFolder(magazine.date, magazine.edition);
        const createFolder = await fetch(
          'http://localhost:3000/web-server-api/createFolder',
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              "date": date,
              "edition": edition
            }),
          }
        );
  
        
        const streamPipeline = promisify(Stream.pipeline);
  
        const response: any = await fetch(
          url, 
          {
            headers: { 'api-key': apiKey }
          }
        );
        
        if (!response.ok){ 
            throw new Error(`unexpected response ${response.statusText}`); 
        }
        
        await streamPipeline(response.body, createWriteStream(fileUri));
        
        setTimeout(async () => {
          await unzip(fileUri, unzipUri);
          resolve(true);
        }, 100);
        


        /*
        const response = await fetch(
          url, 
          {
            headers: { 'api-key': apiKey }
          }
        );

        if (!response.ok){ 
          throw new Error(`unexpected response ${response.statusText}`); 
        }

        //Stream.Readable.fromWeb((await fetch("https://stackoverflow.com")).body).pipe(process.stdout)

        const stream = Stream.Readable.fromWeb(response.body);
        await writeFile(fileUri, stream);

        await unzip(fileUri, unzipUri);
        resolve(true);
        */

  
      }
      else {
        
        const streamPipeline = promisify(Stream.pipeline);
  
        const response: any = await fetch(
          url, 
          {
            headers: { 'api-key': apiKey }
          }
        );
        
        if (!response.ok){ 
            throw new Error(`unexpected response ${response.statusText}`); 
        }
        
        await streamPipeline(response.body, createWriteStream(fileUri));
        
        setTimeout(async () => {
          await unzip(fileUri, unzipUri);
          resolve(true);
        }, 100);
        

        /*
        const response = await fetch(
          url, 
          {
            headers: { 'api-key': apiKey }
          }
        );

        if (!response.ok){ 
          throw new Error(`unexpected response ${response.statusText}`); 
        }

        const stream = Readable.fromWeb(response.body as unknown as NodeJS.ReadableStream);
        await writeFile(fileUri, stream);

        await unzip(fileUri, unzipUri);
        resolve(true);
        */
        
      }
  
      
  
  
      /*
      const downloadResumable = FileSystem.createDownloadResumable(
        url,
        fileUri,
        { headers: { 'api-key': apiKey } }
      );
      const { uri } = await downloadResumable.downloadAsync();
      await unzip(uri, unzipUri);
      */
    } catch (error) {
      console.error('Download and Unzip Images Error:', error);
      reject(false);
    }
  });

};

export const getInfo = async (): Promise<string> => {
  try {
    const result = await fetch(GETINFOURL, {
      method: 'GET',
      headers: { 'api-key': apiKey },
    });
    const response = await result.json();
    return JSON.stringify(response);
  } catch (error) {
    console.error('GetInfo Error:', error);
    return '';
  }
};

export const fetchPreviewImage = async (date: string, edition: string): Promise<boolean> => {
  try {

    await ensureFolderStructure(['epaper', 'epaper/previewImages']);

    const url = `${PREVIEW_IMG_URL}${date}/${edition}/preview`;
    const fileUri = `./epaper/previewImages/${date}.${edition}.jpg`;

    const response = await fetch(url, {
      method: 'HEAD',
      headers: { 'api-key': apiKey },
    });

    if (!response.ok) {
      console.warn(`File not found on server: ${url}`);
      return false;
    }

    const downloadResumable = FileSystem.createDownloadResumable(
      url,
      fileUri,
      { headers: { 'api-key': apiKey } }
    );

    const result = await downloadResumable.downloadAsync();

    if (result?.uri) {
      return true;
    } else {
      console.error('Preview image download did not complete successfully.');
      return false;
    }
  } catch (error) {
    console.error('Error downloading preview image:', error);
    return false;
  }
};

export const fetchSinglePage = async (
  date: string,
  edition: string,
  page: string
): Promise<string | null> => {
  try {
    await ensureFolderStructure(['epaper', 'epaper/temp']);

    const url = `${BASE_FILE_URL}${date}/${edition}/single-page/${page}`;
    const fileUri = `./epaper/temp/${date}.${edition}.${page}.zip`;
    const unzipUri = `./epaper/${date}/${edition}/${page}/`;
    const pdfPath = `${unzipUri}${date}.ZEITUNG.${edition}.${page}_0.pdf`; // Path to extracted PDF

    /*
    const downloadResumable = FileSystem.createDownloadResumable(
      url,
      fileUri,
      { headers: { 'api-key': apiKey } }
    );

    // @ts-ignore
    const { uri } = await downloadResumable.downloadAsync();
    //console.log(`Downloaded SINGLE-PAGE: ${uri}`);

    await unzip(uri, unzipUri);
    await deleteFile(fileUri);

    //console.log(`Unzipped to: ${pdfPath}`);
    */

    const streamPipeline = promisify(Stream.pipeline);
  
    const response = await fetch(
      url, 
      {
        headers: { 'api-key': apiKey }
      }
    );
    
    if (!response.ok){ 
        throw new Error(`unexpected response ${response.statusText}`); 
    }
    
    await streamPipeline(response.body, createWriteStream(fileUri));
    
    await unzip(fileUri, unzipUri);
    await deleteFile(fileUri);

    return pdfPath; // Return path of the extracted PDF
  } catch (error) {
    console.error('Download and Unzip Error:', error);
    //deleteEpaperFolder(date, edition);
    return null; // Return null if there's an error
  }
};

export const ensureFolderStructure = async (folders: string[]): Promise<void> => {
  for (const folder of folders) {

    const response: any = await fetch(
      'http://localhost:3000/web-server-api/checkIfFolderExists',
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          "folder": folder
        }),
      }
    );

    const folderExists = await response.json();

    if (!folderExists.response) {
      await createFolderByString(folder);
    }



    /*
    const folderExists = await checkIfFolderExistsByString(folder);
    if (!folderExists) {
      await createFolderByString(folder);
      //console.log(`Created folder: ${folder}`);
    }
    */
  }
};

/*

export const fetchSingle = async (date: string, edition: string): Promise<boolean> => {

  console.log('fetchSingle - send true');

  return true;


  try {
    //createFolder(date, edition);

    const epaperFolderExists = await checkIfFolderExistsByString('epaper');

    if(!epaperFolderExists) {
      await createFolderByString('epaper');
    }

    const url = `https://one-app.boyens-api.de/api/file/${date}/${edition}/single`;
    const fileUri = FileSystem.documentDirectory + `epaper/${date}.${edition}.zip`;
    const unzipUri = FileSystem.documentDirectory + `epaper/${date}/${edition}/`;

    const downloadResumable = FileSystem.createDownloadResumable(
      url,
      fileUri,
      { headers: { 'api-key': apiKey } }
    );

    // @ts-ignore
    //const { uri } = await downloadResumable.downloadAsync();




    //console.log(`downloaded SINGLE`)
    //await unzip(uri, unzipUri);
    await deleteFile(fileUri);
    //console.log(`unzipped SINGLE: ${unzipUri}`)
    return true;
  } catch (error) {
    console.error('Download and Unzip Error:', error);
    deleteEpaperFolder(date, edition)
    return false;
  }
};

export const fetchImages = async (date: string, edition: string): Promise<boolean> => {

  console.log('fetchImages - send true');

  return true;


  try {
    //createFolder(date, edition);
    const url = `https://one-app.boyens-api.de/api/file/${date}/${edition}/images`;
    const fileUri = FileSystem.documentDirectory + `epaper/${date}.${edition}_img.zip`;
    const unzipUri = FileSystem.documentDirectory + `epaper/${date}/img/`;

    const downloadResumable = FileSystem.createDownloadResumable(
      url,
      fileUri,
      { headers: { 'api-key': apiKey } }
    );
    // @ts-ignore
    const { uri } = await downloadResumable.downloadAsync();
    //console.log(`downloaded IMAGES`)
    //await unzip(uri, unzipUri);
    await deleteFile(fileUri);
    //console.log(`unzipped IMAGES: ${unzipUri}`);    
    return true;
  } catch (error) {
    console.error('Download and Unzip Images Error:', error);
    deleteEpaperFolder(date, edition)
    return false;
  }
};
*/
